import { JsonProperty } from '~app/shared/json-mapper';

export class SSOConfigModel {
  clientId: string = void 0;
  host: string = void 0;
  redirectUri: string = void 0;
  resource: string = void 0;
  postLogoutRedirectUri: string = void 0;
  scope: string = void 0;
  claims: string = void 0;
}

export class ProductConfigModel {
  name: string = void 0;
  avatar: string = void 0;
  appUrl: string = void 0;
  aboutUrl?: string = void 0;
}

export class ProductsConfigModel {
  [key: string]: ProductConfigModel;
}

export class StateConfigModel {
  apiUrl: string = void 0;
  @JsonProperty({ type: SSOConfigModel })
  sso: SSOConfigModel = void 0;
  products: ProductsConfigModel = void 0;
  features: Record<string, boolean> = void 0;
}
